import React, { useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

const BRANCH = process.env.REACT_APP_ENV_RESOURCE;
const Logout = () => {

  useEffect(() => {
    try {
      // Clear local storage or any state management that holds user data
      console.log("Logging out")
      localStorage.removeItem("accessToken_" + BRANCH)
      localStorage.removeItem("refreshToken_"+BRANCH)
      window.location.href = "/login"


    } catch (error) {
      console.error("Logout failed: ", error)
    }
  }, []);

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);